import {
  Login,
  ForgotPassword,
  ResetPassword,
  SelectCompany,
  LoginSso,
  OnlyEmployeeRole,
  Invite,
  TwoFactorRequired,
} from "./pages";

const authUserRoutes = [
  {
    path: "/user/login",
    element: <Login />,
  },
  {
    path: "/user/forgot",
    element: <ForgotPassword />,
  },
  {
    path: "/user/reset-password/:token",
    element: <ResetPassword />,
  },
  {
    path: "/user/select-company",
    element: <SelectCompany />,
  },
  {
    path: "/user/login/sso",
    element: <LoginSso />,
  },
  {
    path: "/user/invite/:token",
    element: <Invite />,
  },
  {
    path: "/only-employee-role",
    element: <OnlyEmployeeRole />,
  },
  {
    path: "/user/login/two-factor-required",
    element: <TwoFactorRequired />,
  },
  {
    path: "/user/login/two-factor-required/:email",
    element: <TwoFactorRequired />,
  },
];

export default authUserRoutes;
